import { render } from "./Figure.vue?vue&type=template&id=45423b62&scoped=true"
import script from "./Figure.vue?vue&type=script&lang=js"
export * from "./Figure.vue?vue&type=script&lang=js"

import "./Figure.vue?vue&type=style&index=0&id=45423b62&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src218436265/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45423b62"]])

export default __exports__